import Vue from "vue";
import VueRouter, { NavigationGuardNext, Route, RouteConfig } from "vue-router";
import StudentEntry from "@/views/studentClassRoom/student-entry.vue";
import StudentClassroom from "../views/studentClassRoom/student-classroom.vue";
import StudentClassroomMobile from "../views/studentClassRoom/student-classroom-mobile.vue";
import FusionClass from "../views/fusionClass/fusion-class.vue";
import TeacherClassroom from "../views/teacherClassRoom/teacher-classroom.vue";
import AuthService from "./../services/auth.service";
import FreeClassRoomJoin from '../views/loginFreeJoin/join.vue'
import FreeCreate from '../views/free/free-create.vue'
import FreeCreateDetail from '../views/free/free-create-detail.vue'
import FreeCreateDetailMobile from '../views/free/free-create-detail-mobile.vue'
import { UserType } from "@/ts/Enum";
import VideoDemo from '../views/fusionClass/video-demo.vue'

Vue.use(VueRouter);
const isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) !== null;

enum statusEnum {
    local = 1, remote = 2
}

class Bread {
    name: string;
    path: string;
    //1本地路由,2远程路由跳转到teacherweb首页（this.filePre.loginUrl）
    status: statusEnum = statusEnum.local;
    urlType: string;
    isClickCallBack = false;

    constructor(name: string, path: string,
        urlType?: string,
        status?: statusEnum,
        isClickCallBack?: boolean
    ) {
        this.name = name;
        this.path = path;
        this.urlType = urlType;
        if (status) {
            this.status = status;
        }
        if (null != isClickCallBack) {
            this.isClickCallBack = isClickCallBack;
        }

    }
}


const baseBreadList: Bread[] = [
    new Bread(
        "首页",
        isMobile ? "/judgment-paper/login" : "/moduleEntry",
        isMobile ? "teacherWebMobile" : "loginUrl",
        statusEnum.remote)
]
const studentBaseBreadList: Bread[] = [
    new Bread(
        "首页",
        "/moduleEntry",
        "studentAirClassRoomUrl",
        statusEnum.remote,
        true
    )
]
const freeJoinBreadList: Bread[] = [
    new Bread(
        "首页",
        "/freeClassroomJoin",
        "freeClassroomUrl",
        statusEnum.local)
]

const freeCreateBreadList: Bread[] = [
    new Bread(
      "首页",
      "/freeCreate",
      "freeClassroomUrl",
      statusEnum.local)
]
const routes: Array<RouteConfig> = [

    {
        path: "/",
        redirect: "/fusionClass"
    },
    {
        // 学生马良笔双师课堂入口页面
        path: "/studentEntry",
        name: "StudentEntry",
        component: StudentEntry,
        meta: {
            breadList: [...studentBaseBreadList, new Bread("马良笔双师课堂", "/")]
        }
    },
    {
        //学生课堂
        path: "/studentClassroom",
        name: "StudentClassroom",
        component: StudentClassroom,
        meta: {
            breadList: [...studentBaseBreadList, new Bread("马良笔双师课堂", "/studentEntry"), new Bread("学生参与马良笔双师课堂", "/")]
        }
    },
    {
        //学生课堂
        path: "/studentClassroomMobile",
        name: "StudentClassroomMobile",
        component: StudentClassroomMobile,
        meta: {
            breadList: [...studentBaseBreadList, new Bread("马良笔双师课堂", "/studentEntry"), new Bread("学生参与马良笔双师课堂", "/")]
        }
    },

    {
        // 教师马良笔双师课堂课表页面
        path: "/fusionClass",
        name: "FusionClass",
        component: FusionClass,
        // component: () =>
        //     import(/* webpackChunkName: "about" */ "../views/fusionClass/fusion-class.vue"),
        meta: {
            breadList: [...baseBreadList, new Bread("马良笔双师课堂", "/")]
        }
    },
    {
        //教师课堂
        path: "/teacherClassroom",
        name: "TeacherClassroom",
        component: TeacherClassroom,
        // component: () =>
        //     import(/* webpackChunkName: "about" */ "../views/teacherClassRoom/teacher-classroom.vue"),
        meta: {
            breadList: [...baseBreadList, new Bread("马良笔双师课堂", "/fusionClass"), new Bread("教师发起授课", "/")]
        }
    },
    {
        // 自由加入马良笔双师课堂的入口页面
        path: '/freeClassroomJoin',
        name: 'FreeClassroomJoin',
        component: FreeClassRoomJoin,
    },
    {
        // 自由加入马良笔双师课堂的入口页面
        path: '/freeCreate',
        name: 'FreeCreate',
        component: FreeCreate,
    },
    {
        // 自由加入马良笔双师课堂的入口页面
        path: '/freeCreateDetail',
        name: 'FreeCreateDetail',
        component: FreeCreateDetail,
        meta: {
            breadList: [...freeCreateBreadList, new Bread("教师发起授课", "/")]
        }
    },
    {
        // 自由加入马良笔双师课堂的入口页面
        path: '/freeCreateDetailMobile',
        name: 'FreeCreateDetailMobile',
        component: FreeCreateDetailMobile,
        meta: {
            breadList: [...freeCreateBreadList, new Bread("教师发起授课", "/")]
        }
    },
    {
        // 自由加入马良笔双师课堂的入口页面
        path: '/videoDemo',
        name: 'VideoDemo',
        component: VideoDemo,
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes: routes,
});

//路由拦截
router.beforeEach(async (to: Route, from: Route, next: NavigationGuardNext) => {
    const name = to.name;
    switch (name) {
        // case 'About':
        // case 'Test':
        // case 'Home':
        //     next();
        //     break;
        //跳转到学生马良笔双师课堂入口页面,是从其他项目跳转过来的，需要登录获取学生信息
        case 'StudentEntry':
            studentEntryRouter(to, from, next);
            break;
        //跳转到学生课堂,是从其他项目跳转过来的，需要登录获取学生信息
        case 'StudentClassroom':
        case 'StudentClassroomMobile':
            rtcParticipantDetailRouter(to, from, next);
            break;
        //跳转到老师融汇课堂，是从其他项目跳转过来的，需要登录获取老师信息
        case 'FusionClass':
            teacherRouter(to, from, next);
            break;
        //   如果是自由加入马良笔双师课堂项目，直接进入，不需要TOKEN
        case 'FreeClassroomJoin':
        case 'FreeCreate':
        case 'FreeCreateDetail':
        case 'FreeCreateDetailMobile':
        case 'VideoDemo':
            noNeedLoginRouter(to, from, next)
            break
        //剩余的是本项目内容
        default:
            otherRouter(to, from, next);
            break;
    }


});


/**
 * 访问学生页面
 * @param to
 * @param from
 * @param next
 */
function studentEntryRouter(to: Route, from: Route, next: NavigationGuardNext) {

    // 获取路由携带参数
    const qToken = to.query && to.query.token ? to.query.token.toString() : "";

    if (qToken) {
        Vue.prototype.local$.clearLocal();
        window.localStorage.setItem("LWToken", qToken);
        Vue.prototype.cookie$.saveCookie("token", qToken);
    }

    const userInfo = window.localStorage.getItem("userInfo");
    const LWToken = window.localStorage.getItem("LWToken");
    const cookie = Vue.prototype.cookie$.getCookie("token");
    if (null == cookie || undefined == cookie || "" == cookie || "null" == cookie) {
        if (LWToken) {
            Vue.prototype.cookie$.saveCookie("token", LWToken);
        }
    }

    let isLogin = false;
    if (userInfo && LWToken && cookie && LWToken === cookie) {
        isLogin = true;
    }

    if (!isLogin) {
        AuthService.getStudentAuthInfo().then(response => {
            console.log("获取登录信息接口返回：", response);
            if (response) {
                window.localStorage.setItem("userId", response.id);
                window.localStorage.setItem("displayName", response.name);
                window.localStorage.setItem("userInfo", JSON.stringify(response));
                window.localStorage.setItem("gardenId", response.gardenId);
                next({ name: to.name, query: {} });
            } else {
                studentRouterError();
            }
        }).catch(error => {
            studentRouterError();
        });
    } else {
        if ("" != qToken) {
            next({ name: to.name, query: {} });
        } else {
            next();
        }
    }
}

function rtcParticipantDetailRouter(to: Route, from: Route, next: NavigationGuardNext) {
    // 获取路由写到的params参数，如果参数中的userType为noLoggedIn，直接进入。
    // 如果参数中的userType为student或者teacher，校验时候有对应的登录信息，有就直接进入。没有就退回到首页
    // 进入之前，需要先将导航信息更改为对应的导航信息。
    const params = to.params
    // 如果路由没有携带任何参数，则跳转到登录页
    if (!params) {
        teacherRouterLogin()
    }
    // 未登录用户进入马良笔双师课堂详情页
    if (params.user_type === UserType.notLoggedIn) {
        to.meta.breadList = [...freeJoinBreadList, new Bread('课堂直播间', '/')]
        next()
    } else if (params.user_type === UserType.student) {
        to.meta.breadList = [...studentBaseBreadList, new Bread('马良笔双师课堂', '/studentEntry'), new Bread('课堂直播间', '/')]
        studentEntryRouter(to, from, next)
    } else if (params.user_type === UserType.teacher) {
        to.meta.breadList = [...baseBreadList, new Bread('马良笔双师课堂', '/fusionClass'), new Bread('课堂直播间', '/')]
        teacherRouter(to, from, next)
    }


}

/**
 * 不需要登录的路由地址
 * @param to
 * @param from
 * @param next
 */
function noNeedLoginRouter(to: Route, from: Route, next: NavigationGuardNext) {
    const gardenId = to.query && to.query.gardenId ? to.query.gardenId.toString() : ''
    if (gardenId) {
        window.localStorage.setItem('gardenId', gardenId)
    }
    next()
}
/**
 * 访问教师融汇课堂，需要token和教师信息
 * @param to
 * @param from
 * @param next
 */
function teacherRouter(to: Route, from: Route, next: NavigationGuardNext) {
    const qToken = to.query && to.query.id ? to.query.id.toString() : "";
    const gardenId = to.query && to.query.gardenId ? to.query.gardenId.toString() : "";

    if (qToken) {
        Vue.prototype.local$.clearLocal();
        window.localStorage.setItem("LWToken", qToken);
        Vue.prototype.cookie$.saveCookie("token", qToken);
    }

    const userInfo = window.localStorage.getItem("userInfo");
    const LWToken = window.localStorage.getItem("LWToken");
    const cookie = Vue.prototype.cookie$.getCookie("token");
    if (null == cookie || undefined == cookie || "" == cookie || "null" == cookie) {
        if (LWToken) {
            Vue.prototype.cookie$.saveCookie("token", LWToken);
        }
    }
    let isLogin = false;
    if (userInfo && LWToken && cookie && LWToken === cookie) {
        isLogin = true;
    }

    if (!isLogin) {
        userIsNoLogin(to, next, LWToken, gardenId);
    } else {
        if ("" != qToken) {
            next({ name: to.name, query: {} });
        } else {
            next();
        }
    }
}

function userIsNoLogin(to: Route, next: NavigationGuardNext, LWToken, gardenId) {
    if (LWToken) {
        getAuthInfo(to, next, gardenId);
    } else {
        teacherRouterLogin();
    }
}

function getAuthInfo(to: Route, next: NavigationGuardNext, gardenId) {
    AuthService.getAuthInfo().then(response => {
        if (response) {
            // 缓存用户信息
            window.localStorage.setItem("userId", response.accountId);
            window.localStorage.setItem("displayName", response.displayName);

            if (gardenId) {
                window.localStorage.setItem("gardenId", gardenId);
                window.localStorage.setItem("userInfo", JSON.stringify(response));
            } else {
                if (response.gardens && response.gardens[0]) {
                    window.localStorage.setItem("gardenId", response.gardens[0].gardenId);
                }
            }
            if (to.name != "login") {
                next({ name: to.name });
            }
        }
    });
}

function teacherRouterLogin() {
    window.open(Vue.prototype.filePre$.loginUrl, "_self");
}

/**
 *学生跳转异常，需要回跳到学生项目
 */
function studentRouterError() {
    window.location.href = Vue.prototype.filePre$.studentAirCLassRoomUrl;
}

/**
 * 本项目路由拦截，如果有token放行，没有跳转到教师登录页
 * @param to
 * @param from
 * @param next
 */
function otherRouter(to: Route, from: Route, next: NavigationGuardNext) {
    const LWToken = window.localStorage.getItem("LWToken");
    if (LWToken) {
        next();
    } else {
        teacherRouterLogin();
    }

}

export default router;
